import React from "react";
import { Card, CardBody, Col } from "reactstrap";

interface WidgetItem {
  id: number;
  icon?: string;
  label: string;
  counter: number | string;
  bgColor?: string;
}

interface WidgetsProps {
  data: WidgetItem[];
}

const formatCurrency = (value: number | string) => {
  // Ensure value is a number
  const num = typeof value === "string" ? parseFloat(value) : value;
  if (isNaN(num)) return value;
  return `$${num.toLocaleString("en-US")}`;
};

const Widgets: React.FC<WidgetsProps> = ({ data }) => {
  return (
    <>
      {(data || []).map((item, idx) => (
        <Col xs={12} sm={6} md={4} lg={12 / data?.length} key={item.id || idx}>
          <Card
            style={{
              backgroundColor: item.bgColor || "inherit",
              // borderRadius: "50%",
              paddingTop: "1rem",
              paddingBottom: "1rem",
              paddingLeft: "0.5rem",
              paddingRight: "0.5rem",
            }}
          >
            <CardBody>
              <div className="d-flex align-items-center">
                {/* <div className="avatar-sm flex-shrink-0">
                  <span className="avatar-title bg-light text-dark rounded-circle fs-3">
                    <i className={"align-middle " + item.icon}></i>
                  </span>
                </div> */}
                <div className="flex-grow-1 ms-3">
                  <p
                    className="fw-normal fs-15 text-black mb-1"
                    style={{ fontSize: "1rem" }}
                  >
                    {item.label}
                  </p>
                  <h4 className="mb-0 text-black" style={{ fontSize: "2rem" }}>
                    {item.label.toLowerCase().includes("earning")
                      ? formatCurrency(item.counter)
                      : item.counter}
                  </h4>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      ))}
    </>
  );
};

export default Widgets;
